<template lang="html">
  <div class="">
    <div class="catalogue" v-for="(b, index) in catalogue" :key="index">
      <div v-if="b.chapter_type == 'chapter'">
        <div class="chapter_list" @click="chapterList(b)">{{b.title}}</div>
        <div class="child_list" v-show="b.slide">
          <div v-for="(c, index) in b.child" :key="index">
            <div v-if="c.chapter_type == 'unit'">
              <div class="unit_list" @click="chapterList(c)">{{c.title}}</div>
              <div v-show="c.slide">
                <div v-for="(d, index) in c.child" :key="index">
                  <div class="lesson_list">{{d.title}}</div>
                </div>
              </div>
            </div>
            <div v-if="c.chapter_type == 'lesson'">
              <div class="lesson_list">{{c.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="b.chapter_type == 'unit'">
        <div class="chapter_list" @click="chapterList(b)">{{b.title}}</div>
        <div v-show="b.slide">
          <div v-for="(z, index) in b.child" :key="index">
            <div class="unit_list">{{z.title}}</div>
          </div>
        </div>
      </div>
      <div v-else-if="b.chapter_type == 'lesson'">
        <div class="chapter_list">{{b.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['catalogueList'],
    data() {
      return {
        catalogue: this.catalogueList,
      }
    },
    watch: {
      catalogueList(newVal, oldVal) {
        if (newVal != oldVal) {
          this.catalogue = newVal;
        }
      }
    },
    mounted() {
      
    },
    methods: {
      chapterList(unm) {
        unm.slide = !unm.slide;
        this.catalogue = [...this.catalogue];
      }
    },
  }
</script>

<style lang="css" scoped>
  /* 目录 */
  .catalogue {
    /* background-color: #04DDAB; */
  }

  .chapter_list {
    height: 5.5rem;
    line-height: 5.5rem;
    font-size: 1.6rem;
    color: #1D2023;
    background-color: #FFFFFF;
    border-bottom: .1rem solid rgba(0, 0, 0, 0.1);
  }

  .child_list {
    background-color: #F8F9FB;
    margin-left: 1.5rem;
    box-sizing: border-box;
    padding: 1rem;
    border-radius: .8rem;
  }

  .unit_list {
    height: 4.4rem;
    line-height: 4.4rem;
    font-size: 1.4rem;
    color: #1D2023;
    border-bottom: .1rem solid rgba(0, 0, 0, 0.1);
  }

  .lesson_list {
    height: 4.4rem;
    line-height: 4.4rem;
    font-size: 1.4rem;
    color: #606972;
    margin-left: 1.5rem;
  }
</style>
